import React  from "react";
import { PositionedBox } from "../../assets/ui";
import ModalOverlay from "./modal-overlay";
///////////////////////////////////////////////////////////////////////////////////////////////////

const SimpleModal = ({ open, children, hideModal }) => {

  return (
    <ModalOverlay open={open} hideModal={hideModal}>
      <PositionedBox
        left="50%"
        top="50%"
        overflow="hidden"
        position="absolute"
        width="fit-content"
        borderTopLeftRadius="8px"
        borderTopRightRadius="8px"
        transition="all 0.5s linear"
        opacity={`${open ? "1" : `0`}`}
        transform={`scale(${open ? "1" : `0.95`}) translate(-50%, -50%)`}
      >
        {children}
      </PositionedBox>
    </ModalOverlay>
  );
};

export default SimpleModal;
